import React from 'react';
import classNames from 'classnames';

import css from './ListingSellerCard.module.css';
import ResponsiveImage from '../ResponsiveImage/ResponsiveImage';

const ListingSellerCard = props => {
  const { className, listing, config } = props;

  if (!listing) return null;

  const {
    contractEndOwnerFirstName,
    contractEndOwnerLastName,
    contractEndOwnerCompanyName,
    contractEndOwnerCompanyLocation,
    contractEndOwnerCompanyImage,
  } = listing.attributes.metadata || {};

  const name =
    contractEndOwnerCompanyName || `${contractEndOwnerFirstName} ${contractEndOwnerLastName}`;

  return (
    <div className={classNames(css.root, className)}>
      {name === 'Husqvarna' ? (
        <ResponsiveImage
          alt={config.marketplaceName}
          image={config.branding.favicon}
          variants={['square48']}
          className={css.img}
        />
      ) : (
        contractEndOwnerCompanyImage && (
          <img src={contractEndOwnerCompanyImage} alt={name} className={css.img} />
        )
      )}
      <div className={css.content}>
        <div className={css.info}>{name}</div>
        {contractEndOwnerCompanyLocation ? (
          <div className={css.location}>{contractEndOwnerCompanyLocation.address} </div>
        ) : null}
      </div>
    </div>
  );
};

export default ListingSellerCard;
